import { FeedbackSuggestedPlanModel } from '../../suggestions/components/plan_feedback/models/feedback_suggested_plan_model';
import { RoleTypeStrategy } from '../strategies/user_mode_api_strategy';

interface IAdvisorCourseGroupPayload {
  term: object;
  course_group: object;
  suggested_plan: number;
  program_slot: number;
}

interface IStudentCourseGroupPayload {
  course_group: number | string;
  program_slot: number;
  term: number;
}

export class APCourseGroupPayloadServant {
  constructor(private $state: ng.ui.IStateService, private ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel) {}

  payload(data: any) {
    const userType = RoleTypeStrategy.evaluate(this.$state);
    if (userType === 'advisor') {
      return {
        term: {
          id: data.term
        },
        course_group: {
          nk: data.course_group
        },
        suggested_plan: this.ngFeedbackSuggestedPlanModel.read().id,
        program_slot: data.program_slot
      } as IAdvisorCourseGroupPayload;
    } else {
      return {
        course_group: data.course_group,
        program_slot: data.program_slot,
        term: data.term
      } as IStudentCourseGroupPayload;
    }
  }
}

angular.module('capability-ng-academic-planner').service('ngAPCourseGroupPayloadServant', APCourseGroupPayloadServant);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/servants/ap_course_group_payload_servant.ts